import React from 'react'
import {FaChevronRight} from 'react-icons/lib/fa'

const Component = React.createClass({
  render: function() {
    const style = {
      ...this.props.style,
      display: 'inline',
      // paddingRight: '6px',
    }

    return (
      <div className={this.props.className}
              onClick={this.props.onClick}
              style={style}><FaChevronRight /></div>
      )
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/NextArrow.js